module.exports = __webpack_public_path__ + "static/media/french-fries-icon.25e504cd.png";